import React from 'react'
import PropTypes from 'prop-types'

import ProviderIcon from './ProviderIcon'

const ProviderColumn = ({ provider, className }) => {
  return <ProviderIcon provider={provider} className={className} />
}

ProviderColumn.propTypes = {
  provider: PropTypes.string
}

export default ProviderColumn
